/**
 * @function renderNothing
 * @description - renders an empty component
 */

export const Nothing = () => null;

export default () => Nothing;
